import React, {useEffect, useState} from 'react';
import {Modal, ModalBody} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    getAlarmsConfig,
    getAlarmsConfigLoading,
    getAlarmsConfigPagination,
    getAlarmsModalStatus,
    getDeviceTypes
} from "../../../redux-store/selectors";
import {fetchConfiguredAlarms, hideAlarmsModal} from "../../../redux-store/map";
import {Popconfirm, Select, Table, Tooltip} from "antd";
import {Controller, useForm} from "react-hook-form";
import {REQUIRED_FIELD} from "../../../constants/Messages";
import {
    cloneAlarms,
    createAlarmsConfig,
    deleteAlarmConfig,
    fetchAlarmsConfig,
    updateAlarmsConfig
} from "../../../redux-store/alarms";
import editIcon from "../../../images/Group 28.svg";
import trashIcon from "../../../images/bin.svg";
import AlarmsConfirmationModal from "./AlarmsConfirmationModal";

const {Option} = Select;

const relationArray = [
    {
        value: "EQUALS",
        label: "=",
    },
    {
        value: "NOT_EQUALS",
        label: "≠",
    },
    {
        value: "GREATER_THEN",
        label: ">",
    },
    {
        value: "LOWER_THEN",
        label: "<",
    },
]

const levelSelectData = [
    {
        label: "RED",
        value: "RED",
    },
    {
        label: "ORANGE",
        value: "ORANGE",
    },
    {
        label: "YELLOW",
        value: "YELLOW",
    },
    {
        label: "BLUE",
        value: "BLUE",
    },
    {
        label: "GREEN",
        value: "GREEN",
    },
]
const defaultValues = {
    message: "", parameterName: "activeEnergy", relation: "EQUALS", value: "", delay: 0, level: "RED", reportable: true,
}

const AlarmsModal = ({devices = [], locationId = null, installationId}) => {

    const dispatch = useDispatch();
    const modalVisibility = useSelector(getAlarmsModalStatus);
    const configuredAlarms = useSelector(getAlarmsConfig);
    const configuredAlarmsLoading = useSelector(getAlarmsConfigLoading);
    const [editId, setEditId] = useState(null);

    const {total, currentPage, pageSize} = useSelector(getAlarmsConfigPagination);
    const {
        handleSubmit,
        formState: {isSubmitSuccessful, errors},
        setError,
        register,
        control,
        reset,
        watch,
        setValue
    } = useForm({defaultValues: defaultValues})

    const deviceTypes = useSelector(getDeviceTypes);
    const selectedMethodName = watch("methodName");

    const [selectedDevice, setSelectedDevice] = useState(null);
    const [parameterSelectData, setParameterSelectData] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [methodNames, setMethodNames] = useState([]);

    const onModalClose = () => {
        dispatch(hideAlarmsModal());
    }

    useEffect(() => {
        if (!modalVisibility) return;
        if (devices.length > 0) {
            setSelectedDevice({value: devices[0].id, label: devices[0].model});
        }
    }, [modalVisibility, devices])

    useEffect(() => {
        if (selectedDevice === null || locationId === null) return;
        dispatch(fetchConfiguredAlarms({installationId, locationId, deviceId: selectedDevice.value}));
        dispatch(fetchAlarmsConfig({installationId, locationId, deviceId: selectedDevice.value}));
        const deviceType = deviceTypes.find(item => item.model === selectedDevice.label);
        if (deviceType !== undefined) {
            const selectData = [];
            deviceType.readableParameters.forEach((item) => {
                selectData.push({
                    value: item,
                    label: item
                })
            })
            setParameterSelectData(selectData);
            const methodsSelectData = [];
            deviceType.commandProducers.forEach(item => {
                methodsSelectData.push({
                    value: item,
                    label: item
                })
            })
            setMethodNames(methodsSelectData);
        }
    }, [selectedDevice]);

    const handleDeviceSelectChange = (value) => {
        setSelectedDevice(value);
    }

    const relationOption = relationArray.map((item, key) => {
        return (<Option key={item.value} value={item.value}>{item.label}</Option>)
    })
    const onsubmit = data => {
        data.action = null;
        if (data.methodName !== undefined) {
            const args = JSON.parse("[" + (data.arguments ? data.arguments : "") + "]");
            data.action = {
                "methodName": data.methodName,
                "arguments": args
            }
        }
        delete data.arguments;
        delete data.methodName;
        if (editId !== null) {
            dispatch(updateAlarmsConfig({
                installationId,
                locationId,
                deviceId: selectedDevice.value,
                data,
                alarmId: editId
            }))
            setEditId(null);
            return;
        }
        dispatch(createAlarmsConfig({
            installationId,
            locationId,
            deviceId: selectedDevice.value,
            data

        }))
    }
    const onEdit = data => {

        const {id, delay, level, message, parameterName, relation, reportable, value, action} = data;
        setEditId(id);
        setValue("message", message);
        setValue("parameterName", parameterName)
        setValue("relation", relation)
        setValue("value", value)
        setValue("reportable", reportable)
        setValue("delay", delay)
        setValue("level", level)
        if (action !== null) {

            setValue("methodName", action.methodName);
            const argumentsString = action.arguments.reduce((acc,curr)=>acc+"," +curr);

            setValue("arguments", argumentsString);
        }else{
            setValue("methodName", undefined);
            setValue("arguments","");
        }

    }
    const onEditCancel = () => {
        reset(defaultValues)
        setEditId(null);
    }
    const onDelete = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    }
    const onDeleteSubmit = () => {
        dispatch(deleteAlarmConfig({
            installationId,
            locationId,
            deviceId: selectedDevice.value,
            alarmId: deleteId
        }))
        setShowDeleteModal(false);
        setDeleteId(null);
    }
    const onDeleteModalClose = () => {
        setShowDeleteModal(false);
    }
    const handleConfirmYes = () => {
        handleCloneAlarms({
            installationId: installationId,
            data: {
                deviceId: selectedDevice.value,
                deleteTargetAlarms: true,
            }
        })
    }
    const handleConfirmNo = () => {
        handleCloneAlarms({
            installationId: installationId,
            data: {
                deviceId: selectedDevice.value,
                deleteTargetAlarms: false,
            }
        })
    }
    const handleCloneAlarms = (data) => {
        dispatch(cloneAlarms(data))
    }
    const alarmsConfigTableHeader = [
        {
            title: <Tooltip title="Poruka"><span>Poruka</span></Tooltip>,
            dataIndex: "message",
            key: "message",
        },
        {
            title: <Tooltip title="Parametar"><span>Parametar</span></Tooltip>,
            dataIndex: "parameterName",
            key: "parameterName",
        },
        {
            title: <Tooltip title="Relacija"><span>Relacija</span></Tooltip>,
            dataIndex: "relation",
            key: "relation",
            render: text => {
                const relation = relationArray.find(item => item.value === text);
                if (relation !== undefined)
                    return relation.label;
                else return text;
            }
        },
        {
            title: <Tooltip title="Vrijednost"><span>Vrijednost</span></Tooltip>,
            dataIndex: "value",
            key: "value",
        },
        {
            title: <Tooltip title="Kašnjene"><span>Kašnjene</span></Tooltip>,
            dataIndex: "delay",
            key: "delay",
        },
        {
            title: <Tooltip title="Reportable"><span>Reportable</span></Tooltip>,
            dataIndex: "reportable",
            key: "reportable",
            render: text => text ? "true" : "false"
        },
        {
            title: <Tooltip title="Akcije"><span>Akcije</span></Tooltip>,
            dataIndex: "id",
            key: "id",
            render: (item, row) => {

                return <>
                    <img src={editIcon} alt={"Edit Icon"} onClick={() => onEdit(row)}
                         className={"m-right cursor-button"}/>
                    <img src={trashIcon} alt={"Trash Icon"} onClick={() => onDelete(row.id)}
                         className={"w-icons cursor-button"}/>
                </>
            }
        },
    ]
    return (
        <Modal
            show={modalVisibility}
            onHide={onModalClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>Alarmi</Modal.Title></Modal.Header>
            <ModalBody>
                <AlarmsConfirmationModal show={showDeleteModal} onClose={onDeleteModalClose} onSubmit={onDeleteSubmit}/>
                <div className={"container"}>
                    <div className={"row mb-2"}>
                        <div className={"col-12"}>
                            <label className="mb-2 form-label" htmlFor="command">Uređај</label>
                            <Select labelInValue loading={false} disabled={false} className={"form-select"}
                                    style={{width: "200px", marginLeft: "10px"}}
                                    onChange={handleDeviceSelectChange} value={selectedDevice}
                                    getPopupContainer={node => node.parentNode}>
                                {devices.map(device => <Option value={device.id}>{device.model}</Option>)}
                            </Select>
                            <Popconfirm placement="top" title={"Obriši alarme na ostalim uređajima?"}
                                        onConfirm={handleConfirmYes} okText="Da" cancelText="Ne"
                                        onCancel={handleConfirmNo}>
                                <button className={"btn btn-modal-confirm clone-alarms-btn"}>
                                    Kloniraj alarme
                                </button>
                            </Popconfirm>
                        </div>
                    </div>
                    <div className={"row pb-3 pt-3 ant-alarm-form"}>
                        <div className={"d-flex justify-content-between align-items-center mb-2"}>
                            <div>
                                <h4> Kreiraj alarm</h4>
                            </div>
                            <div className={"d-flex justify-content-between align-items-center"}>
                                <div>
                                    {editId !== null &&
                                        <button onClick={onEditCancel} className={"btn btn-modal-cancel"}
                                                style={{
                                                    border: "1px solid white", height: "30px",
                                                    fontSize: "16px", padding: "0px 14px"
                                                }}>Otkaži izmjenu</button>}
                                </div>
                                <div className={"device-add-icon"}>
                                    <button className={"btn btn-modal-confirm"} onClick={handleSubmit(onsubmit)}
                                            style={{padding: "7px 20px"}}>
                                        {editId !== null ? "Izmijeni" : "Kreiraj"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit(onsubmit)} className={"column"}>
                            <div className={"row"}>
                                <div className={"col-12 col-md-12 col-lg-2 col-xl-2"}>
                                    <label className="mb-2 form-label font-size-label" htmlFor="command">Poruka</label>
                                    <input type={"text"} className={"form-control"}
                                           {...register("message", {required: REQUIRED_FIELD})}/>
                                </div>
                                <div className={"col-12 col-md-12 col-lg-3 col-xl-3 form-modal-select"}>
                                    <label className="mb-2 form-label" htmlFor="parameterName">Parametar</label>
                                    <Controller
                                        control={control}
                                        name={"parameterName"}
                                        render={({
                                                     field: {onChange, value, ref},
                                                 }) => (<Select
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                            showSearch
                                        >
                                            {parameterSelectData.map(item => <Option
                                                value={item.value}>{item.label}</Option>)}
                                        </Select>)}
                                        rules={{required: REQUIRED_FIELD}}
                                    />
                                </div>
                                <div className={"col-12 col-12 col-lg-1 col-xl-1 form-modal-select"}>
                                    <label className="mb-2 form-label" htmlFor="relation">Relacija</label>
                                    <Controller
                                        control={control}
                                        name={"relation"}
                                        render={({
                                                     field: {onChange, value, ref},
                                                 }) => (<Select
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {relationOption}
                                        </Select>)}
                                        rules={{required: REQUIRED_FIELD}}
                                    />
                                </div>
                                <div className={"col-12 col-md-12 col-lg-2 col-xl-2"}>
                                    <label className="mb-2 form-label font-size-label"
                                           htmlFor="command">Vrijednost</label>
                                    <input type={"text"} className={"form-control"}
                                           {...register("value", {required: REQUIRED_FIELD})}/>
                                </div>
                                <div className={"col-12 col-md-12 col-lg-1 col-xl-1"}>
                                    <label className="mb-2 form-label font-size-label"
                                           htmlFor="command">Kašnjenje</label>
                                    <input type={"number"} className={"form-control"}
                                           {...register("delay", {required: REQUIRED_FIELD, min: 0})} min={0}/>
                                </div>
                                <div className={"col-12 col-md-12 col-lg-2 col-xl-2 form-modal-select"}>
                                    <label className="mb-2 form-label font-size-label" htmlFor="command">Level</label>
                                    <Controller
                                        control={control}
                                        name={"level"}
                                        render={({field: {onChange, value, ref}}) => (
                                            <Select
                                                onChange={onChange}
                                                value={value}
                                                ref={ref}
                                                className={"form-select"}
                                                getPopupContainer={node => node.parentNode}
                                            >
                                                {levelSelectData.map(item => <Option
                                                    value={item.value}>{item.label}</Option>)}
                                            </Select>)}
                                        rules={{required: REQUIRED_FIELD}}
                                    />
                                </div>
                            </div>
                            <div className={"row mt-1"}>
                                <div className={"col-12 col-md-12 col-lg-3 col-xl-3 form-modal-select"}>
                                    <label className="mb-2 form-label" htmlFor="parameterName">Ime metode</label>
                                    <Controller
                                        control={control}
                                        name={"methodName"}
                                        render={({
                                                     field: {onChange, value, ref},
                                                 }) => (<Select
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                            showSearch
                                            allowClear
                                        >
                                            {methodNames.map(item => <Option
                                                value={item.value}>{item.label}</Option>)}
                                        </Select>)}
                                    />
                                </div>
                                <div className={"col-12 col-md-12 col-lg-2 col-xl-3"}>
                                    <label className="mb-2 form-label font-size-label"
                                           htmlFor="command">Argumenti</label>
                                    <input type={"text"} className={"form-control"}
                                           {...register("arguments")}
                                           disabled={selectedMethodName !== undefined ? false : true}/>
                                </div>
                                <div className={"col-12 col-md-12 col-lg-2 col-xl-2"}>
                                    <label className="mb-2 form-label font-size-label"
                                           htmlFor="command">Reportable</label>
                                    <div className={"d-flex align-items-center h-50"}><input type={"checkbox"}
                                                                                             className="form-check-input"
                                                                                             {...register("reportable")} />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className={"row pt-2 pb-2 alarm-table"}>
                        <Table showSorterTooltip={false} columns={alarmsConfigTableHeader} dataSource={configuredAlarms}
                               size="middle"
                               scroll={{
                                   x: 900,
                                   y: 350,
                               }}
                               loading={configuredAlarmsLoading}
                               pagination={false}
                        />
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default AlarmsModal;
